import { Button, ButtonsGroup, Modal, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { useSegment } from '../../../../../../../../hooks'
import { useOrganizationViewUrl } from '../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../../utils/routing/reactRoute'

interface CreateDepositInvoiceEntryPointModalFooterProps {
  id: string
}

export const CreateDepositInvoiceEntryPointModalFooter = ({
  id,
}: CreateDepositInvoiceEntryPointModalFooterProps): ReactElement => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { track } = useSegment()
  const { close } = useModal(id)

  const { url: quotesUrl } = useOrganizationViewUrl(reactRoute.organization.quotes.getMainRoute())

  const handleLaterButtonClick = useCallback(() => {
    track('XXX - Invoicing Core - Invoices List - Deposit onboarding modal - Maybe later clicked')
    close()
  }, [close, track])

  const handleGoToQuotesButtonClick = useCallback(() => {
    track('XXX - Invoicing Core - Invoices List - Deposit onboarding modal - Go to quotes clicked')
    close()
    if (quotesUrl) {
      navigate(quotesUrl)
    }
  }, [close, navigate, quotesUrl, track])

  return (
    <Modal.Footer>
      <ButtonsGroup>
        <Button variant="tonal" onClick={handleLaterButtonClick}>
          {t('external_invoices.deposit_invoice.create_deposit_invoice_entry_point_modal.footer.maybe_later')}
        </Button>
        <Button variant="filled" onClick={handleGoToQuotesButtonClick}>
          {t('external_invoices.deposit_invoice.create_deposit_invoice_entry_point_modal.footer.go_to_quotes')}
        </Button>
      </ButtonsGroup>
    </Modal.Footer>
  )
}
